/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Code from 'components/Code';
import Table, {Row, Column} from 'components/Table';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    ol: "ol",
    li: "li",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      children: _jsx(_components.code, {
        children: "isStyledComponent"
      })
    }), "\n", _jsx(_components.p, {
      children: "A utility to help identify styled components."
    }), "\n", _jsx(Table, {
      head: ['Arguments', 'Description'],
      children: _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsxs(_components.ol, {
            children: ["\n", _jsxs(_components.li, {
              children: ["\n", _jsx(Code, {
                children: "Function"
              }), "\n"]
            }), "\n"]
          })
        }), _jsx(Column, {
          children: _jsx(_components.p, {
            children: "Any function expected to possibly be a styled component or React component\nwrapped in a styled component"
          })
        })]
      })
    }), "\n", _jsx(_components.p, {
      children: "Returns true if the passed function is a valid styled components-wrapped component class. It can be useful for determining if a component needs to be wrapped such that it can be used as a component selector:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import React from 'react'\nimport styled, { isStyledComponent } from 'styled-components'\nimport MaybeStyledComponent from './somewhere-else'\n\nlet TargetedComponent = isStyledComponent(MaybeStyledComponent)\n  ? MaybeStyledComponent\n  : styled(MaybeStyledComponent)``\n\nconst ParentComponent = styled.div`\n  color: royalblue;\n\n  ${TargetedComponent} {\n    color: #E42200;\n  }\n`\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
